/**
 * v-if-has-permission custom directive.
 * Checks if the given permission is present on the current user permissions list
 *
 * args:
 *  hide, disable (default)
 *
 * usage:
 *  <my-component v-if-has-permission.hide="'viewActionExample'" /> # apply the style display=none to the
 *  component my-component.
 *
 *  <button v-if-has-permission="'deleteActionExample'" /> # attach disabled attribute to the button element.
 *
 * Note:
 * Use it with permissions plugin (vm.$permissions) to centralize permission name refactoring.
 */

import store from '../store/index';

const directiveDefinition = {
  inserted(el, binding) {
    if (!binding.value) return;
    const element = el;
    const behavior = binding.arg === 'hide' ? 'hide' : 'disable';
    const hasPermission = store.getters.user.permissions.includes(binding.value);
    if (!hasPermission) {
      if (behavior === 'disable') {
        element.disabled = 'disabled';
      } else {
        element.style.display = 'none';
      }
    }
  },
};

export default directiveDefinition;
